import { useState, useMemo, useCallback } from "react";

/**
 * Custom hook for search and filter functionality
 * @param {Array} data - Data array to search/filter
 * @param {Function} searchFn - Function to determine if an item matches the search
 * @returns {Object} Search state and handlers
 */
export const useSearch = (data = [], searchFn) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = useMemo(() => {
    if (!searchTerm.trim()) {
      return data;
    }
    return data.filter(item => searchFn(item, searchTerm));
  }, [data, searchTerm, searchFn]);

  const hasNoResults = useMemo(() => {
    return searchTerm.trim() !== "" && filteredData.length === 0;
  }, [searchTerm, filteredData]);

  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchTerm("");
  }, []);

  return {
    searchTerm,
    filteredData,
    hasNoResults,
    handleSearchChange,
    clearSearch,
  };
};
